module.exports = __webpack_public_path__ + "static/testimonialLayoutBack-6a3fa1e168f283a7e2e8ea8a41b401de.png";